<template>
  <div v-if="hideGuaranteeMsg" class="comparator__card__panel">
    <img class="comparator__card__panel__img" :src="imageSrc">
    <p class="comparator__card__panel__text">
      <span v-html="text"></span>
      <router-link :to="{ name: 'comparator' }" class="link">
        {{ $t('home.comparator.offersDisplayed.here') }}
      </router-link>
    </p>
  </div>
  <div v-else>
    <div class="comparator__text">
      <span v-html="text"></span>
      <router-link :to="{ name: 'comparator' }" class="link">
        {{ $t('home.comparator.offersDisplayed.here') }}
      </router-link>
    </div>
    <div class="comparator__card__panel">
      <img class="comparator__card__panel__img smaller" :src="guaranteeSrc">
      <div class="comparator__card__panel__text smaller">
        <p class="comparator__card__panel__title">{{ guaranteeTitle }}</p>
        <p>{{ guaranteeText }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import demandHelper from '@/utils/helpers/demand';
import guaranteeImg from '@/assets/img/guarantee-days.png';

export default {
  name: 'offersDisplayed',
  props: {
    isCommissionnaire: {
      type: Boolean,
    },
  },
  computed: {
    ...mapGetters({
      offers: 'offerStore/offers',
      demand: 'demandStore/demand',
    }),
    imageSrc() {
      return 'https://cdn.nextories.com/static/img/ccm_devis.png';
    },
    guaranteeSrc() {
      return guaranteeImg;
    },
    guaranteeDays() {
      return 5;
    },
    hideGuaranteeMsg() {
      if (this.isCommissionnaire) {
        return true;
      }
      const today = new Date();
      const date = new Date(this.demand.comp_sent_date);
      const startDate = new Date('2022-04-26');
      const days = Math.ceil((today - date) / (1000 * 60 * 60 * 24));
      return date < startDate || days > this.guaranteeDays;
    },
    guaranteeTitle() {
      const date = new Date(this.demand.comp_sent_date);
      date.setDate(date.getDate() + this.guaranteeDays);
      return this.$t('home.comparator.offersDisplayed.guarantee.title', { limitDate: demandHelper.formatDate(date) });
    },
    guaranteeText() {
      return this.$t('home.comparator.offersDisplayed.guarantee.text', { guaranteeDays: this.guaranteeDays });
    },
    text() {
      return this.offers.length === 1
        ? this.$t('home.comparator.offersDisplayed.description.offer')
        : this.$t('home.comparator.offersDisplayed.description.offers', { nb: this.offers.length });
    },
  },
};
</script>

<style scoped lang="scss">
.comparator__text {
  margin-bottom: 20px;
}
.comparator__card__panel {
  &__img.smaller {
    width: 100px;
  }
  &__title {
    color: #ff9460;
    font-weight: bold;
  }
  &__text.smaller {
    font-size: 0.9em;
  }
}
</style>
